import { useCallback, useEffect, useState } from 'react';
import * as api from '../api/client';

const HUBS = [
  { key: 'davetiyeler', label: 'Davetiyeler' },
  { key: 'sekerlik', label: 'Şekerlik' },
];

const emptyForm = { slug: '', title: '', shortTitle: '', description: '' };

export default function CategoriesPage() {
  const [hub, setHub] = useState('davetiyeler');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.getCategories(hub);
      setItems(data);
    } finally {
      setLoading(false);
    }
  }, [hub]);

  useEffect(() => { load(); }, [load]);

  const openCreate = () => {
    setForm({ mode: 'create', ...emptyForm });
    setError('');
  };

  const openEdit = (item) => {
    setForm({
      mode: 'edit',
      id: item.id,
      slug: item.slug,
      title: item.title,
      shortTitle: item.shortTitle,
      description: item.description,
    });
    setError('');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const payload = {
        slug: form.slug.trim(),
        title: form.title.trim(),
        shortTitle: form.shortTitle.trim(),
        description: form.description.trim(),
      };
      if (form.mode === 'create') {
        await api.createCategory(hub, payload);
      } else {
        await api.updateCategory(hub, form.id, payload);
      }
      setForm(null);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu kategoriyi silmek istediğinize emin misiniz?')) return;
    try {
      await api.deleteCategory(hub, id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <header className="admin-header">
        <h2>Kategoriler</h2>
        <p>Davetiye ve şekerlik kategorilerini yönetin</p>
      </header>

      <div className="admin-content">
        <div className="admin-tabs">
          {HUBS.map((h) => (
            <button
              key={h.key}
              type="button"
              className={hub === h.key ? 'active' : undefined}
              onClick={() => setHub(h.key)}
            >
              {h.label}
            </button>
          ))}
        </div>

        {error && !form && <div className="admin-alert admin-alert--error">{error}</div>}

        <div className="admin-page-actions">
          <h3>{HUBS.find((h) => h.key === hub)?.label} kategorileri</h3>
          <button type="button" className="admin-btn admin-btn--primary" onClick={openCreate}>
            + Kategori ekle
          </button>
        </div>

        {form && (
          <div className="admin-card" style={{ marginBottom: '1.25rem' }}>
            <h3 className="admin-section-title">
              {form.mode === 'create' ? 'Yeni kategori' : 'Kategori düzenle'}
            </h3>
            {error && <div className="admin-alert admin-alert--error">{error}</div>}
            <form className="admin-form" onSubmit={handleSave}>
              <div className="admin-grid-2">
                <div className="admin-field">
                  <label htmlFor="cat-slug">Slug (URL)</label>
                  <input
                    id="cat-slug"
                    value={form.slug}
                    onChange={(e) => setForm({ ...form, slug: e.target.value })}
                    placeholder="dugun"
                    required
                  />
                </div>
                <div className="admin-field">
                  <label htmlFor="cat-short">Kısa başlık</label>
                  <input
                    id="cat-short"
                    value={form.shortTitle}
                    onChange={(e) => setForm({ ...form, shortTitle: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="admin-field">
                <label htmlFor="cat-title">Başlık</label>
                <input
                  id="cat-title"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  required
                />
              </div>
              <div className="admin-field">
                <label htmlFor="cat-desc">Açıklama</label>
                <textarea
                  id="cat-desc"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                />
              </div>
              <div className="admin-form-actions">
                <button type="submit" className="admin-btn admin-btn--primary" disabled={saving}>
                  {saving ? 'Kaydediliyor…' : 'Kaydet'}
                </button>
                <button type="button" className="admin-btn admin-btn--secondary" onClick={() => setForm(null)}>
                  İptal
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="admin-table-wrap">
          {loading ? (
            <div className="admin-empty">Yükleniyor…</div>
          ) : items.length === 0 ? (
            <div className="admin-empty">Henüz kategori yok</div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Başlık</th>
                  <th>Slug</th>
                  <th>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td><code>{item.slug}</code></td>
                    <td>
                      <div className="admin-table__actions">
                        <button type="button" className="admin-btn admin-btn--secondary admin-btn--sm" onClick={() => openEdit(item)}>
                          Düzenle
                        </button>
                        <button type="button" className="admin-btn admin-btn--danger admin-btn--sm" onClick={() => handleDelete(item.id)}>
                          Sil
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
